$(function(){
  if($("#map_canvas").length > 0){ init_map("map_canvas", true); }
});

function init_map(container_id, draggable){
  var context = {};
    context.container = container_id;
    context.map = null;
    context.geocoder= null;
    context.marker= null;
    context.draggable = draggable;

  initialize_gmap(context);
  
  $(".find_on_map").on("click",function(){
  	showAddressOnMap(get_address(), context)
  });
  
  $("#geolocalization").tooltip();
}

function initialize_gmap(context){
  var options = {
    id: context.container,
    center_latitude: 41.609282,
    center_longitude: 14.669065,
    zoom: 8,
    type: "HYBRID"
  };

  context.map = new google.maps.Map(document.getElementById(options.id), {
    zoom: options.zoom,
    center: new google.maps.LatLng(options.center_latitude, options.center_longitude),
    mapTypeId: google.maps.MapTypeId[options.type] || google.maps.MapTypeId.ROADMAP,
    draggable: context.draggable
  });

  context.geocoder = new google.maps.Geocoder();

  // mostra un marker con le coordinate iniziali
  if(lat_long_present()){ showCoordinatesOnMap(context); }
}


function showCoordinatesOnMap(context){
  var lat= $(".latitude").val(),
  lng = $(".longitude").val(),
  position = new google.maps.LatLng(lat, lng);
  
  context.geocoder.geocode({'location' : position}, function(results, status){
    if(status == google.maps.GeocoderStatus.OK){
      show_pin(position, context);
    }
  });
}

function showAddressOnMap(address, context){
  context.geocoder.geocode({'address' : address}, function(results, status){
    if(status == google.maps.GeocoderStatus.OK){
      var position = results[0].geometry.location;
      show_pin(position, context);
    }
  });
}

function show_pin(position, context){
  if (!context.info_window){
    context.info_window= new google.maps.InfoWindow();
  }
  center_map(position, context);
  place_marker(position, context);
  updateLatLng(context);
  if(context.draggable){
    google.maps.event.addListener(context.marker, "dragstart", function(){
      if(context.info_window.opened){
        close_info_window(context);
      }
    });

    google.maps.event.addListener(context.marker, "dragend", function(){
      updateLatLng(context);
      context.map.setCenter(context.marker.getPosition());
    });  	
  }

  google.maps.event.addListener(context.marker, "click", function(){
    context.info_window.setContent(context.marker.getPosition().toString());
    if(!context.info_window.opened){
      open_info_window(context);
      } else {
      close_info_window(context);
    }
  });
}

function close_info_window(context){
  context.info_window.close();
  context.info_window.opened= false;
}
	
function open_info_window(context){
  context.info_window.open(context.map, context.marker);
  context.info_window.opened= true;
}

function place_marker(position, context){
  if(!context.marker){
    context.marker = new google.maps.Marker({
      draggable: context.draggable,
      map: context.map,
      position: position
    });
    } else {
	  context.marker.setPosition(position);
  }
}

function center_map(position, context){
  context.map.setCenter(position);
  context.map.setZoom(17);
}

function updateLatLng(context){
  var lat_lng= context.marker.getPosition();
  $(".latitude").val(lat_lng.lat());
  $(".longitude").val(lat_lng.lng());
}

function get_address(){
  var address;
  if($(".full_address").length < 1){
    address = "Italia, " + " " + $(".municipality").val() + " " + $(".address").val();
    } else { address= $(".full_address").val()}
  return address;
}

function update_address(){
  var address;
  if($(".full_address").length < 1){
    address= "Italia, " + " " + $(".municipality").val() + " " + $(".province").val() + " " + $(".cap").val() + " " + $(".address").val();
  } else { address= $(".full_address").val()}
    showAddressOnMap(address);
}

function update_coordinates(context){

  var lat= $(".latitude").val(),
    lng= $(".longitude").val();
   showCoordinatesOnMap(lat, lng, context);
  
}

function address_present(address){
  return address != undefined && address != ""
}

function lat_long_present(){
  return $(".latitude").val().length > 0 && $(".longitude").val().length > 0
}

function is_numeric(event){
  return jQuery.inArray( event.keyCode, [48,49,50,51,52,53,54,55,56,57]) != -1;
}

window.init_map = init_map;